import CellHOC from '@platform/react/hoc/list/cell'
import StatusChip from 'ui/Element/Text/StatusChip'

const styles = (theme) => ({
  root: {},
})

/**
 * Displays information about the status of a measurement.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
const ListItemCellXEcoApmStatus = (classes, props = {}) => {
  const { status: statusNumber, events } = props
  const status = events?.getStatus?.(statusNumber || 0) || []

  return (
    <StatusChip
      shape={'rounded'}
      size={'small'}
      value={status}
    />
  )
}

export default CellHOC(ListItemCellXEcoApmStatus, styles)
